<template>
  <div class="box">
    <div class="boxTop">
      <div class="headBox">
        <div class="headLeft">
          <img src="@/assets/images/logo.png" alt="">
        </div>
        <div class="headRight">
          <div class=headRightTel>
            <img src="@/assets/images/phone.png" alt="">
            官方电话：400-999-6541
          </div>
          <div class="headRightLogin">
            <div class="headRightDl" @click="to('/login')" v-show="info">机构登录</div>
            <div class="headRightD3" @click="dialogFormVisible = true" v-show="info">免费申请</div>
            <div class="headRightD" @click="toSy" v-show="!info">进入系统</div>
            <a :href="code"> <img src="@/assets/images/anniu.png" alt=""></a>
          </div>
        </div>
      </div>
    </div>

    <div class="banner">
      <img src="@/assets/images/notbanner.png" alt="">
    </div>

    <div class="haha">
      <div class="haha-title">
        <img src="@/assets/images/1-.png" alt="">
      </div>
      <div class="tab">
        <div class="item">
          <div class="img">
            <img src="@/assets/images/1-1.png" alt="">
          </div>
          <div class="tit">专家管理分散，不统一</div>
          <div class="xian"></div>
          <div class="tex">
            社会组织专家涉及多领域、多行业，<br>
            分布在不同的地区，较分散，管理起来比较<br>困难不能及时快速的进行整合管理。
          </div>
        </div>
        <div class="item">
          <div class="img">
            <img src="@/assets/images/1-2.png" alt="">
          </div>
          <div class="tit">专家预约流程繁琐</div>
          <div class="xian"></div>
          <div class="tex">
            传统专家预约需进行手写登记，<br>
            预约的流程较为繁琐，并且<br>访客预约资料堆积如山，整理费时费力。
          </div>
        </div>
        <div class="item">
          <div class="img">
            <img src="@/assets/images/1-3.png" alt="">
          </div>
          <div class="tit">预约信息和记录留档难</div>
          <div class="xian"></div>
          <div class="tex">
            传统的预约信息、预约记录均为纸质版本，<br>
            存档容易损坏遗失，也需要更多的空间，<br>并且查找预约信息也较为困难。
          </div>
        </div>
      </div>

    </div>

    <div class="hehe">
      <div class="haha-title">
        <img src="@/assets/images/2-.png" alt="">
      </div>
      <div class="hehe-img">
        <img src="@/assets/images/2-1.png" alt="">
        <img src="@/assets/images/2-2.png" alt="">
      </div>
    </div>

    <div class="oyou">
      <img src="@/assets/images/3-.png" alt="">
    </div>

    <div class="ovf">
      <img src="@/assets/images/4-1.png" alt="">
      <img src="@/assets/images/4-2.png" alt="">
    </div>

    <div class="oyou">
      <img src="@/assets/images/5-.png" alt="">
    </div>

    <div class="det">
      <div class="img">
        <img src="@/assets/images/footlogo.png" alt="">
      </div>
      <div class="dkj">
        <div class="tex">
          <p>立刻<span @click="dialogFormVisible = true">免费试用</span>一个月</p>
          <p>咨询电话：<span>13121702211</span> 任老师</p>
          <p>立刻拿起电话咨询吧！</p>
          <p>扫描右方二维码加微信或者直接电话联系</p>
        </div>
        <div class="ewm">
          <img src="@/assets/images/ewmzc.png" alt="">
        </div>
      </div>
    </div>

    <div class="end">
      Copyright © 知诚会
      <a href="https://beian.miit.gov.cn/" target="_blank" style="color: rgb(255, 255, 255);">京ICP备17050284号-7</a>
      <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802037085" target="_blank"
         class="margin-lr-xs" style="color: rgb(255, 255, 255);">
        <img src="http://www.beian.gov.cn/img/new/gongan.png" alt="">公安备案号：11010802037085</a>
      北京易魔方科技集团有限公司 版权所有

    </div>
    <el-dialog
        title=""
        :visible.sync="dialogFormVisible"
        custom-class="shenqBox"
        center
    >
      <div class="imgs" style="width: 100%;padding-bottom: 20px;text-align: center;font-size: 24px;font-weight:bold;">
        社会组织专家智库系统
      </div>
      <el-form :model="formA" :rules="rules" ref="formA" class="demo-ruleForm">
        <el-form-item label="机构名称：" :label-width="formLabelWidth" prop="name">
          <el-input v-model="formA.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人：" :label-width="formLabelWidth" prop="ren">
          <el-input v-model="formA.ren" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：" :label-width="formLabelWidth" prop="tel">
          <el-input v-model="formA.tel" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" style="width: 100px;height: 40px;">取 消</el-button>
        <el-button type="primary" @click="shenq" style="width: 100px;height: 40px;margin-left: 40px;">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

export default {
  name: "notLogin",
  data() {
    var validatePass = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的手机号'));
      } else {
        callback();
      }
    };
    return {
      tab: 1,
      info: true,
      search: '',
      code: 'http://fw.zhichenghui.org.cn',
      dialogFormVisible: false,
      formLabelWidth: '120px',
      formA: {
        name: '',
        ren: '',
        tel: '',
      },
      rules: {
        name: [
          {required: true, message: '请输入机构名称', trigger: 'blur'}
        ],
        ren: [
          {required: true, message: '请输入联系人', trigger: 'blur'}
        ],
        tel: [
          {validator: validatePass, trigger: 'blur'}
        ],
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  created() {
    if (this.user) {
      this.info = false
      this.code = 'http://fw.zhichenghui.org.cn/tiaoz.html?code=' + this.user.emofUserTokenSafer + '&path=index.html'
    }
  },
  methods: {
    //免费申请
    shenq() {
      this.$refs.formA.validate((valid) => {
        var that = this
        console.log(valid)
        if (valid) {
          var xhr = new XMLHttpRequest();
          xhr.open('post', 'http://fw.zhichenghui.org.cn/index.php/home/login/organizationApply');
          xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
          xhr.send('organizationName=' + this.formA.name + '&contactsPeople=' + this.formA.ren + '&contactsPhone=' + this.formA.tel + '&sourceFrom=益书宝');
          xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status === 200) {
              var error = JSON.parse(xhr.responseText);
              that.$message.success(error.msg);
              this.dialogFormVisible = false
            }
          };
        }
      })


    },

    to(path) {
      this.$router.push(path)
    },
    // 跳转首页
    toSy() {
      if (!this.user) {
        this.$router.push({
          path: '/login',
          query: {
            rout: "/home"
          }
        })
      } else {
        this.$router.push("/home")
      }
    }
  },
  watch: {}
}
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 100%;

  .boxTop {
    width: 100%;
    background-color: #0a2240;

    .headBox {
      width: 1200px;
      margin: 0 auto;
      height: 130px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .headRight {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .headRightTel {
          font-size: 16px;
          color: #ffffff;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-right: 10px;
          img {
            margin-right: 5px;
          }
        }

        .headRightLogin {
          display: flex;
          justify-content: space-between;

          div {
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            color: #ffffff;
            cursor: pointer;
          }

          .headRightDl {
            width: 100px;
            height: 40px;
            text-align: center;
            line-height: 38px;
            font-size: 16px;
            color: #fff;
            border-radius: 20px;
            background-color: #ff9600;
            border-radius: 20px 0 0 20px;
          }
          .headRightD3 {
            width: 100px;
            height: 40px;
            text-align: center;
            line-height: 38px;
            font-size: 16px;
            color: #fff;
            border-radius: 20px;
            background-color: #ff9600;
            border-radius: 0 20px 20px 0;
          }

          .headRightD {
            width: 150px;
            height: 40px;
            text-align: center;
            line-height: 38px;
            font-size: 16px;
            color: #fff;
            border-radius: 20px;
            background-color: #ff9600;
            border-radius: 20px;
          }
          a {
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            color: #fff;
            text-align: center;
            margin: 0 5px;
          }
        }
      }
    }
  }

  .banner {
    width: 100%;
    img {
      display: block;
      max-width: 100%;
    }
  }

  .haha {
    width: 100%;
    background-color: #eff5fa;
    padding: 70px 0;
    .haha-title {
      width: 100%;
      img {
        display: block;
        margin: 0 auto;
      }
    }
    .tab {
      width: 100%;
      display: flex;
      justify-content: center;
      .item {
        width: 380px;
        height: 464px;
        background-color: #ffffff;
        margin: 0 15px;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
        align-items: center;
        .img {
          width: 100%;
          img {
            display: block;
            margin: 0 auto;
          }
        }
        .tit {
          width: 100%;
          text-align: center;
          font-size: 28px;
          letter-spacing: 2px;
          color: #0a2240;
          font-weight: bold;
          padding-top: 40px;
        }
        .xian {
          width: 36px;
          height: 1px;
          background-color: #ff9600;
          margin: 30px auto;
        }
        .tex {
          width: 100%;
          text-align: center;
          font-size: 18px;
          line-height: 28px;
          letter-spacing: 1px;
          color: #666666;
          padding: 0 8px;
        }
      }
    }
  }

  .hehe {
    width: 100%;
    background: url('../../assets/images/notBGC1.png') no-repeat;
    background-size: 100% 100%;
    padding: 70px 0;
    padding-bottom: 150px;
    .haha-title {
      width: 100%;
      img {
        display: block;
        margin: 0 auto;
      }
    }
    .hehe-img {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 90px;
      img {
        display: block;
        margin: 0 20px;
      }
    }
  }

  .oyou {
    width: 100%;
    padding: 100px 0;
    img {
      display: block;
      margin: 0 auto;
    }
  }

  .ovf {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 120px 0;
    background: url('../../assets/images/notBGC2.png') no-repeat;
    background-size: 100% 100%;
    img {
      display: block;
      margin: 0 20px;
    }
  }

  .det {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 40px;
    padding-bottom: 20px;
    background-color: #0a2240;
    .img {
      margin-right: 230px;
    }
    .dkj {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .tex {
        width: 464px;
        height: 97px;
        background: rgba(255,255,255,.1);
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        align-content: center;
        padding: 0 30px;
        p {
          font-size: 14px;
          color: #ffffff;
          line-height: 34px;
          span {
            color: #ff9600;
            cursor: pointer;
          }
        }
      }
      .ewm {
        width: 96px;
        height: 96px;
        background-color: #f4f4f4;
        border-radius: 10px;
        padding: 5px;
        margin-left: 15px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }


  .end {
    width: 100%;
    height: 60px;
    background-color: #0a2240;
    line-height: 60px;
    font-size: 14px;
    color: #fff;
    text-align: center;
  }
}


</style>
